import { HttpContextToken } from '@angular/common/http';

/**
 * Opt out of the global 403 toast for a single request. Honoured by the
 * `httpErrorInterceptor` in `@zag/auth/ui`.
 *
 * For reads the UI degrades gracefully (inline empty/error states, e.g.
 * person-page widgets or the entity-access dialog's revoked state), a 403
 * means "not allowed for this entity" — expected, not actionable, so the
 * global toast would be pure noise. Writes keep the toast.
 *
 * @example
 * ```typescript
 * this.http.get(url, { context: new HttpContext().set(SKIP_FORBIDDEN_TOAST, true) })
 * ```
 */
export const SKIP_FORBIDDEN_TOAST = new HttpContextToken<boolean>(() => false);
